/**
 * Checks the input value is an Int or a Float, and returns its value or min or max if the number is out of range
 *
 * @param value is a String
 * @param min
 * @param max
 * @param parseNumber
 * @returns {Number}
 */
export const numberInRange = (value, min, max, parseNumber = parseInt) => {
  if (typeof value !== 'number' && !/^\s*\d+(?:.\d+)\s*$/.test(value.toString())) {
    return min != null ? min : 0;
  } else {
    if (max != null && value > parseNumber(max)) {
      return max;
    }
    if (min != null && value < parseNumber(min)) {
      return min;
    }
  }
  return value;
};